import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Mail {
    type: string;
    name: string;
    email: string;
    content: string;
    apiKey: string;
}